/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { Map, useMap } from "@vis.gl/react-google-maps";
import MarkerWithInfoWindow from "./MarkerWithInfoWindow";
import { MAP_DEFAULT_CENTER } from "../consts";

const GMap = ({
  polygonPositionsArray,
  pngMapImageArray,
  imagesLatitudeLongitude,
  imageNames,
  onViewImageClick,
  mapCenter,
  zoomLevel,
}) => {
  const mapInstance = useMap();
  const [addedPolygon, setAddedPolygon] = useState([]);
  const [addedGroundOverlay, setAddedGroundOverlay] = useState([]);
  const createPolygon = ({ polygonArray, color }) => {
    // eslint-disable-next-line no-undef
    const polygon = new google.maps.Polygon({
      paths: polygonArray,
      strokeColor: color,
      strokeOpacity: 1,
      strokeWeight: 3,
      fillOpacity: 0,
    });
    return polygon;
  };
  const updatePolygonAndMap = (polygonPositionsArray, mapInstance) => {
    const polygonArray = [];
    try {
      if (polygonPositionsArray && polygonPositionsArray.length > 0) {
        for (let index = 0; index < polygonPositionsArray?.length; index++) {
          const element = polygonPositionsArray[index];
          if (element?.polygonArray?.length) {
            const polygon = createPolygon(element);
            if (polygon.setMap) {
              polygon.setMap(mapInstance);
            }
            polygonArray.push(polygon);
          }
        }
        setAddedPolygon(polygonArray); // set added polygon
        mapInstance.setZoom(18);
        if (mapCenter) {
          mapInstance.setCenter(mapCenter);
        }
      }
    } catch (err) {}
    return polygonArray;
  };

  const loadImage = () => {
    const overlayArray = [];
    for (let pngMapImageObj of pngMapImageArray) {
      // Initialize variables for min/max latitudes and longitudes
      let minLat = Infinity,
        minLng = Infinity,
        maxLat = -Infinity,
        maxLng = -Infinity;
      pngMapImageObj.polygonArray?.forEach((coord) => {
        if (coord.lat < minLat) minLat = coord.lat;
        if (coord.lat > maxLat) maxLat = coord.lat;
        if (coord.lng < minLng) minLng = coord.lng;
        if (coord.lng > maxLng) maxLng = coord.lng;
      });

      // eslint-disable-next-line no-undef
      const imageBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(minLat, minLng), // Southwest corner
        new google.maps.LatLng(maxLat, maxLng) // Northeast corner
      );

      // eslint-disable-next-line no-undef
      const groundOverlay = new google.maps.GroundOverlay(
        pngMapImageObj?.url, // URL of the image
        imageBounds // The bounds where the image will appear
      );
      groundOverlay.setMap(mapInstance);
      overlayArray.push(groundOverlay);
    }
    setAddedGroundOverlay(overlayArray);
  };
  /// for images
  useEffect(() => {
    if (mapInstance && addedGroundOverlay?.length > 0) {
      for (const element of addedGroundOverlay) {
        element.setMap(null);
      }
      setAddedGroundOverlay([]);
    }
    if (mapInstance && pngMapImageArray?.length > 0) {
      loadImage();
    }
  }, [mapInstance, pngMapImageArray]);

  useEffect(() => {
    if (mapInstance && addedPolygon?.length) {
      for (const element of addedPolygon) {
        element.setMap(null);
      }
      setAddedPolygon([]);
    }
    if (
      !mapInstance ||
      !polygonPositionsArray ||
      polygonPositionsArray?.length === 0
    )
      return;
    updatePolygonAndMap(polygonPositionsArray, mapInstance);
  }, [mapInstance, polygonPositionsArray]);

  const getInfoMarker = () => {
    try {
      const validMarkers = [];
      if (imageNames && imagesLatitudeLongitude) {
        Object.keys(imageNames).forEach((key) => {
          imageNames[key]?.forEach((imageItem, index) => {
            const coords = imagesLatitudeLongitude[imageItem.name];
            if (coords && !coords.includes("not") && coords[0] && coords[1]) {
              validMarkers.push({
                key: `key-marker-${index.toString()}`,
                title: imageItem?.title,
                position: new google.maps.LatLng(
                  Number(coords[1]),
                  Number(coords[0])
                ),
                onClick: () =>
                  onViewImageClick(
                    imageNames[key],
                    Object.keys(imagesLatitudeLongitude),
                    imageItem.name,
                    key
                  ),
              });
            }
          });
        });
      }
      return (
        <>
          {validMarkers.map((marker) => (
            <MarkerWithInfoWindow
              key={marker.key}
              title={marker.title}
              position={marker.position}
              onViewImageClick={marker.onClick}
            />
          ))}
        </>
      );
    } catch (e) {}
    return "";
  };

  return (
    <Map
      defaultCenter={MAP_DEFAULT_CENTER}
      defaultZoom={8}
      gestureHandling="greedy"
      mapId="GMap"
      streetViewControl={true}
      mapTypeControl={true}
      mapTypeId="satellite"
      options={{ streetViewControl: false }}
    >
      {getInfoMarker()}
    </Map>
  );
};

export default React.memo(GMap);
